import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Avatar,
  Tooltip,
  IconButton,
} from "@mui/material";
import { rsProgress } from "../../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseFooterLinks } from "./UseFooterLinks";
import { useNavigate } from "react-router-dom";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomPagination from "../../../../components/CustomPagination";
import { DataGrid, faIR } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DeleteRow from "../../../../components/DeleteRow";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { readFromLS } from "../../../../util/LocalStrogeService";

export default function FooterLinks(props) {
  const navigate = useNavigate();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetFooterLinks, RemoveFooterLinks, SetFooterLinks } =
    UseFooterLinks();
  const [linkRes, setLinkRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });
  const [homePageId, setHomePageId] = useState(
    readFromLS("homePage") ? readFromLS("homePage") : undefined
  );

  useEffect(() => {
    if (props.expanded === "panel2") {
      setProgress(true);
      GetFooterLinks(homePageId?.id ? homePageId.id : 1, (Links) => {
        setLinkRes(Links);
      });
    }
  }, [props.expanded, homePageId]);

  const handleChange = (panel) => (event, isExpanded) => {
    props.setExpanded(isExpanded ? panel : false);
    if (isExpanded) {
      const element = document.getElementById("panel2");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  };

  useEffect(() => {
    if (props.expanded === "panel2") {
      const element = document.getElementById("panel2");
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  }, [props.expanded]);

  const newFunc = () => {
    return navigate("/footerManage/addLink", {
      state: {
        model: linkRes ? linkRes : [],
        expanded: props.expanded,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "ID",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowIndex",
      width: 100,
      align: "center",
      headerName: "اولویت",
      headerAlign: "center",
    },
    {
      field: "title",
      width: 250,
      align: "center",
      headerName: "عنوان",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "icon",
      width: 120,
      align: "center",
      headerName: "آیکن",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Avatar
            sx={{ bgcolor: "#d3d3d3", p: 0.5, borderRadius: 0 }}
            src={cellValues.row.icon}
          ></Avatar>
        );
      },
    },
    {
      field: "عملیات",
      sortable: false,
      width: 160,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  navigate("/footerManage/editLink", {
                    state: {
                      model: cellValues.row,
                      expanded: props.expanded,
                    },
                  });
                }}
              >
                <EditIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    id: cellValues.row.id,
                    name: cellValues.row.title,
                  });
                }}
              >
                <DeleteIcon fontSize="small" sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>{" "}
            <IconButton
              sx={{ p: 0.5, mr: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex - 1,
                };
                if (cellValues.row.rowIndex - 1 == 0) {
                  return;
                } else {
                  SetFooterLinks(model, "", () => {
                    GetFooterLinks(
                      homePageId?.id ? homePageId.id : 1,
                      (Certificates) => {
                        setLinkRes(Certificates);
                      }
                    );
                  });
                }
              }}
            >
              <ArrowDropUpIcon fontSize="small" />
            </IconButton>
            <IconButton
              sx={{ p: 0.5 }}
              onClick={() => {
                let model = {
                  id: cellValues.row.id,
                  rowIndex: cellValues.row.rowIndex + 1,
                };

                if (cellValues.row.rowIndex + 1 == linkRes?.length + 1) {
                  return;
                } else {
                  SetFooterLinks(model, "", () => {
                    GetFooterLinks(
                      homePageId?.id ? homePageId.id : 1,
                      (Certificates) => {
                        setLinkRes(Certificates);
                      }
                    );
                  });
                }
              }}
            >
              <ArrowDropDownIcon fontSize="small" />
            </IconButton>
          </>
        );
      },
    },
  ];

  return (
    <Accordion
      expanded={props.expanded === "panel2"}
      id="panel2"
      onChange={handleChange("panel2")}
      style={{ marginTop: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        // onClick={() => props.setExpanded("panel2")}
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel2bh-content"
        id="panel2bh-header"
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FiberManualRecordIcon color="secondary" fontSize="small" />
          <Typography sx={{ ml: 1 }} color="secondary" variant="subtitle1">
            اطلاعات لینک ها
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ height: "30rem" }}>
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            pageSize={100}
            rows={linkRes ? linkRes : []}
            rowCount={linkRes?.length ? linkRes.length : 1}
            enableRangeSelection={true}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                newFunc: newFunc,
                isLtr: true,
                rowCount: linkRes?.length ? linkRes.length : "",
              },
            }}
          />
        </Box>
        <DeleteRow
          deleteState={deleteState}
          setDeleteState={setDeleteState}
          type={"لینک"}
          callback={() => {
            setProgress(true);
            RemoveFooterLinks(deleteState.id, () => {
              GetFooterLinks(homePageId?.id ? homePageId.id : 1, (Links) => {
                setLinkRes(Links);
              });
            });
          }}
        ></DeleteRow>
      </AccordionDetails>
    </Accordion>
  );
}
